// 单词数据 - 中英文配对
export const wordPairs = [
  { chinese: '苹果', english: 'apple', id: 1 },
  { chinese: '香蕉', english: 'banana', id: 2 },
  { chinese: '橙子', english: 'orange', id: 3 },
  { chinese: '葡萄', english: 'grape', id: 4 },
  { chinese: '草莓', english: 'strawberry', id: 5 },
  { chinese: '西瓜', english: 'watermelon', id: 6 },
  { chinese: '猫', english: 'cat', id: 7 },
  { chinese: '狗', english: 'dog', id: 8 },
  { chinese: '鸟', english: 'bird', id: 9 },
  { chinese: '鱼', english: 'fish', id: 10 },
  { chinese: '书', english: 'book', id: 11 },
  { chinese: '笔', english: 'pen', id: 12 },
  { chinese: '电脑', english: 'computer', id: 13 },
  { chinese: '手机', english: 'phone', id: 14 },
  { chinese: '太阳', english: 'sun', id: 15 },
  { chinese: '月亮', english: 'moon', id: 16 },
  { chinese: '星星', english: 'star', id: 17 },
  { chinese: '云', english: 'cloud', id: 18 },
  { chinese: '树', english: 'tree', id: 19 },
  { chinese: '花', english: 'flower', id: 20 }
];

// 生成游戏卡片数据
export const generateGameCards = (level = 1) => {
  const pairs = [...wordPairs];
  const cardCount = Math.min(8 + level * 4, pairs.length); // 根据关卡增加卡片数量
  const selectedPairs = pairs.slice(0, cardCount);
  
  // 创建中英文卡片
  const cards = [];
  selectedPairs.forEach(pair => {
    // 中文卡片
    cards.push({
      id: `chinese-${pair.id}`,
      text: pair.chinese,
      type: 'chinese',
      pairId: pair.id,
      matched: false
    });
    
    // 英文卡片
    cards.push({
      id: `english-${pair.id}`,
      text: pair.english,
      type: 'english',
      pairId: pair.id,
      matched: false
    });
  });
  
  // 随机打乱卡片顺序
  return cards.sort(() => Math.random() - 0.5);
};